import Toolbar from "toolbar/Toolbar";
import ToolbarItemBasic from "toolbar/ToolbarItemBasic";
import ToolbarItemList from "toolbar/ToolbarItemList";
import Ajax from "base/Ajax";
import SessionTracker from "adminUsers/SessionTracker";
import Message from "base/Message";
import AccountDetailsModal from "adminUsers/AccountDetailsModal";
import ToolbarItemLink from "toolbar/ToolbarItemLink";
import AjaxPageLoader from "webPage/AjaxPageLoader";
import $ from "jquery";

if (window.User) {
    Toolbar.addDefaultItem(new ToolbarItemList(window.User.name, [
        new ToolbarItemBasic('Account Details', () => {
            const modal = new AccountDetailsModal();
            modal.show();
        }, 'account-details'),
        new ToolbarItemBasic('Logout', () => {
            Ajax.delete("adminUsers", "login", {}, Ajax.ADMIN).then(function () {
                window.location.reload();
            }, function (e) {
                new Message(e.message, "Couldn't log you out");
            })
        }, 'logout')
    ], 'account'), 1, Toolbar.RIGHT);

    if (window.User.level.effectiveLevel >= 2 /* Admin */) {
        Toolbar.addDefaultItem(new ToolbarItemLink("Admin Users", window.CONFIG.urls.admin + "adminUsers", "admin-users", window.ADMIN_MODULE === "adminUsers"), 2, Toolbar.RIGHT);
    }

    $(function () {
        SessionTracker.start();
    });
    AjaxPageLoader.on('beforeLoading', () => false);
}
